<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_carga"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px;"
                >Nº Carga</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_trecho"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px;"
                >Nº Trecho</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Inicial"
              v-model="dt_inicio"
              reset-button
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Final"
              v-model="dt_fim"
              reset-button
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="4" class="m-t-5px p-a-0">
            <multiselect
              v-model="transportadora"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsTransportadora"
              track-by="value"
              label="label"
              id="transportadora"
              :hide-selected="true"
              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingTransportadora"
              @search-change="listaTransportadora"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      num_carga: "",
      num_trecho: "",
      dt_inicio: "",
      dt_fim: "",
      transportadora: [],
      optionsTransportadora: [],
      isLoadingTransportadora: false,
      data_filter: [],
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
    };
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        num_carga: this.num_carga,
        num_trecho: this.num_trecho,
        transportadora: this.transportadora,
        dt_inicio: this.dt_inicio,
        dt_fim: this.dt_fim,
      };
      this.$events.fire("filterModal-set", this.data_filter);
    },
    resetFilter() {
      this.num_carga = ""; // clear the text in text input
      this.num_trecho = "";
      this.transportadora = "";
      this.dt_inicio = "";
      this.dt_fim = "";
      this.$events.fire("filterModal-reset");
    //   this.$events.fire("filterModal-reset");
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            console.log("Entrou 1");
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              console.log("Entrou 2");
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ).replace(
                      /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
                      "$1.$2.$3/$4-$5"
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    formatTypedDate: function(dateString) {
      let result = dateString.split("/");
      return result[2] + "-" + result[1] + "-" + result[0] + "T00:00:00-03:00";
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>